import { Input } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import QRCode from "qrcode.react";
import { useTranslation } from "react-i18next";

import Person1 from "../../images/ReferCode/person_1.webp";
import Arrow from "../../images/ReferCode/exchange.webp";
import PersonTree from "../../images/ReferCode/person_g_4.png";

import { REPLACE_AIR } from "../../replace_str_constant";
import { commonOpacity } from "../../animateConstant";
import { notice } from "../../redux/action/action";
import InputCopy from "../../components/CopyComponent/InputCopy";
import ReferTitle from "./components/ReferTitle";
import { RULES } from "./components/Rule";
import ReferWrap from "./components/ReferWrap";
import { HiChevronRight } from "react-icons/hi";
import { CURRENCY_SYMBOL } from "../../constant";
import ReferColumn from "./components/ReferColumn";
import { formatNumber } from "../../utils/formatNumber";
import TimePicker from "../../components/TimePicker/TimePicker";
import { getToday } from "../../utils/getDay";
import { useEffect, useMemo, useState } from "react";
// import { getReferDetail } from "../../api/api";
import { storeReferDetail } from "../../redux/action/member/memberAction";
import LoadingIcon from "../../components/Loading/LoadingIcon";
import RuleDetail from "./components/RuleDetail";
import { globalLink } from "../../config";

const ReferCode = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`referral.${key}`);

  const [datePicker, setDatePicker] = useState([getToday(), getToday()]);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const memberData = useSelector((state) => state.isMemberInfo);
  const referDetail = useSelector((state) => state.isReferDetail);

  useEffect(() => {
    if (datePicker.length === 1) {
      return;
    }
    setIsLoading(true);
    // getReferDetail({ std: datePicker[0], etd: datePicker[1] })
    //   .then((data) => {
    //     if (data.code === "Ok") {
    //       dispatch(storeReferDetail(data.unlimit_data));
    //     } else {
    //     }
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    //   });
  }, [datePicker]);

  const statisticsList = [
    {
      text: "Reward total",
      value: formatNumber(memberData?.unlimit_total?.commission),
      symbol: true,
    },
    {
      text: "Register total",
      value: memberData?.allchild,
    },
    {
      text: "Deposit total",
      value: 100,
    },
    {
      text: "Yesterday's register",
      value: 100,
    },
    {
      text: "Yesterday's deposit",
      value: 100,
    },
  ];

  const REWARD_LIST = [
    {
      label: "Total Rewards",
      symbol: true,
      value: formatNumber(referDetail?.commission),
    },
    { label: "Total Register Friends", value: memberData?.allchild },
    { label: "Direct Register Friends", value: memberData?.ownchild },
  ];

  const BET_LIST = [
    {
      label: "Your Turnover",
      symbol: true,
      value: formatNumber(referDetail?.selfbet),
    },
    {
      label: "Friends Turnover",
      symbol: true,
      value: formatNumber(referDetail?.agentbet),
    },
    {
      label: "Total Turnover",
      symbol: true,
      value: formatNumber(referDetail?.totalbet),
    },
  ];

  const navigate = useNavigate();

  return (
    <motion.main
      initial={commonOpacity.initial}
      animate={commonOpacity.animate}
      exit={commonOpacity.exit}
      transition={commonOpacity.transition}
      className="px-common-padding-x py-common-padding-y"
    >
      <section
        className="p-[24px] rounded-[5px] text-white"
        style={{
          background: "linear-gradient(219.1deg,#9aff98,#2654ca 101.02%)",
        }}
      >
        <p className="font-extrabold text-[18px] text-center mb-[5px] sm:text-lg">
          {i18n("topcontent")}
        </p>
        <p className="font-extrabold text-xs text-[15px] text-center sm:text-lg">
          {i18n("content1")}
          <span className="text-main-color mx-[7px] text-base">
            {CURRENCY_SYMBOL} 1,000
          </span>
          {i18n("content2")}
          <span className="text-main-color mx-[7px] text-base">0.60%</span>{" "}
          {i18n("content3")}
        </p>
        <section className="mt-[16px] flex flex-col items-center justify-center">
          <div className="w-[46px] p-[2px] rounded-[6px] bg-[#b4ffdf]">
            <div className="bg-[#4EE0B5] w-full flex flex-col items-center justify-center rounded-[6px]">
              <p className="text-xs text-center text-white font-extrabold mb-[2px]">
                You
              </p>
              <img src={Person1} className="object-cover w-[30px] h-[32px]" />
            </div>
          </div>
          <div className="mt-[10px] relative">
            <p className="absolute top-[15px] right-[45px]">Bet</p>
            <img className="w-[40px] object-cover" src={Arrow} />
            <p className="absolute top-[15px] left-[45px]">Rewards</p>
          </div>
          <div className="mt-[10px] relative">
            <img src={PersonTree} />
            <div className="absolute flex flex-col items-center absolute-center !top-[75px]">
              <p className="mb-[30px]">Level 1</p>
              <p className="mb-[30px]">Level 2</p>
              <p>Level 3</p>
            </div>
          </div>
        </section>
      </section>
      <section className="mt-[24px] mb-[10px]">
        <ReferTitle title={i18n("myReferral")} />
      </section>
      <TimePicker setDatePicker={setDatePicker} datePicker={datePicker} />
      <div className="my-[10px]"></div>
      <section className="sm:flex gap-[30px] sm:bg-second-color rounded-[10px]">
        <section className="mb-[24px] w-full">
          <ReferWrap>
            <section className="grid grid-cols-3 w-full mb-[10px]">
              {REWARD_LIST.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`py-[8px] px-[5px] md:min-h-[100px] min-h-[80px] flex flex-col items-center justify-between ${
                      index % 2 === 0 && "bg-second-color "
                    } rounded-lg sm:mb-[10px] md:bg-second-color  md:!rounded-none`}
                  >
                    <p className="mb-0 text-light-text text-center font-semibold xl:text-xl sm:text-lg text-sm">
                      {i18n(item.label)}
                    </p>
                    <p className="font-bold sm:text-2xl">
                      <LoadingIcon commonLoading={isLoading}>
                        {item.symbol && CURRENCY_SYMBOL} {item.value}
                      </LoadingIcon>
                    </p>
                  </div>
                );
              })}
            </section>
            <section className="grid w-full mb-[10px]">
              {BET_LIST.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`py-[8px] px-[5px] flex  items-center justify-between ${
                      index % 2 === 0 && "bg-second-color "
                    } rounded-lg sm:mb-[10px] md:bg-second-color  md:!rounded-none`}
                  >
                    <p className="mb-0 text-light-text text-center font-semibold xl:text-xl sm:text-lg text-sm">
                      {i18n(item.label)}
                    </p>
                    <p className="font-bold sm:text-2xl">
                      <LoadingIcon commonLoading={isLoading}>
                        {item.symbol && CURRENCY_SYMBOL} {item.value}
                      </LoadingIcon>
                    </p>
                  </div>
                );
              })}
            </section>

            <p className="font-extrabold mb-[5px] sm:text-2xl sm:mt-[20px]">
              {i18n("link")}
            </p>
            <InputCopy
              copyLink={`${globalLink}/#/signup?invitecode=${memberData?.invitecode}`}
            />
            <p className="font-extrabold my-[5px] sm:text-2xl sm:mt-[20px]">
              {i18n("code")}
            </p>
            <InputCopy copyLink={`${memberData?.invitecode}`} />
            <p className="font-extrabold my-[5px] sm:text-2xl sm:mt-[20px]">
              QRCode
            </p>

            <section className="flex item-center">
              <div className="p-[5px] bg-second-color">
                <QRCode
                  value={`${globalLink}/#/signup?invitecode=${memberData?.invitecode}`}
                  renderAs="canvas"
                />
              </div>
            </section>
          </ReferWrap>
        </section>

        <section className="mb-[24px] w-full">
          <ReferWrap>
            <section className="flex items-center justify-between mb-[20px]">
              <p className="mb-0 font-extrabold sm:text-2xl">
                {" "}
                {i18n("statistics")}
              </p>
              <div
                className="text-main-color flex items-center sm:text-lg cursor-pointer"
                onClick={() => navigate("betRecord")}
              >
                <p className="mb-0 font-bold"> {i18n("history")}</p>
                <HiChevronRight className="text-lg" />
              </div>
            </section>
            <section>
              {statisticsList.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`p-[8px] flex items-center justify-between ${
                      index % 2 === 0 && "bg-second-color sm:bg-transparent"
                    } rounded-lg sm:mb-[10px]`}
                  >
                    <p className="mb-0 text-light-text font-semibold xl:text-xl sm:text-lg text-sm">
                      {i18n(REPLACE_AIR(item.text))}
                    </p>
                    <p className="font-bold sm:text-3xl">
                      {item.symbol && CURRENCY_SYMBOL} {item.value}
                    </p>
                  </div>
                );
              })}
            </section>
          </ReferWrap>
        </section>
      </section>

      <section className="mb-[10px] mt-[24px]">
        <ReferTitle title={i18n("myReward")} />
        <ReferWrap>
          <ReferColumn title={i18n("firstDeposit")} value="0.00" border />
          <ReferColumn title={i18n("firstDepositOfYesterday")} value="0.00" />
        </ReferWrap>
      </section>

      <section className="my-[24px]">
        <ReferWrap>
          <ReferColumn title={i18n("bettingRewards")} value="0.00" border />
          <ReferColumn title={i18n("bettingRewardOfYesterday")} value="0.00" />
        </ReferWrap>
      </section>

      <section className="my-[24px]">
        <ReferTitle title={i18n("rule")} />
        <RuleDetail />
      </section>
    </motion.main>
  );
};

export default ReferCode;
